import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=700a266e&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=700a266e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a266e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActivityCard: require('/workspace/components/ActivityCard.vue').default})
